import { useEffect } from "react";

import { FeatureCode } from "@wallet-manager/node-types";

import { Box } from "../../../components/MuiGenerals";
import { usePermission, useTabs, useTranslation } from "../../../hooks";
import { useAppDispatch } from "../../../reducer/hooks";
import {
  resetLiquidityProviderParams,
  resetMerchantTabParams,
} from "../CrossMerchantTransferPath/reduxContext";
import LiquidityProviderTab from "./LiquidityProviderTab";
import MerchantTab from "./MerchantTab";

export const PERMISSION_KEY = FeatureCode.FeaturesLedger.ClientBalance;

const MERCHANT_TAB_PERMISSION = PERMISSION_KEY.TabMerchant.prefix;
const LIQUIDITY_PROVIDER_TAB_PERMISSION =
  PERMISSION_KEY.TabLiquidityProvider.prefix;

export const TRANSLATE_PREFIX = "ledgerClientBalance";

function ClientBalance() {
  const { t } = useTranslation(TRANSLATE_PREFIX);

  const { hasPermission } = usePermission();
  const dispatch = useAppDispatch();

  const tabConfigArr = [
    { name: t("merchant"), value: MERCHANT_TAB_PERMISSION },
    {
      name: t("liquidity_provider"),
      value: LIQUIDITY_PROVIDER_TAB_PERMISSION,
    },
  ].filter(({ value }) => hasPermission(value));

  const { Tabs, tabValue } = useTabs(tabConfigArr);

  useEffect(() => {
    dispatch(resetLiquidityProviderParams());
    dispatch(resetMerchantTabParams());
  }, [tabValue]);

  return (
    <Box
      sx={{
        backgroundColor: "white",
        ">div": {
          ">div": {
            paddingTop: "2rem",
            ":first-of-type": {
              margin: "0 1.5rem",
            },
          },
        },
      }}
    >
      <Tabs>
        {tabValue === MERCHANT_TAB_PERMISSION && <MerchantTab />}
        {tabValue === LIQUIDITY_PROVIDER_TAB_PERMISSION && (
          <LiquidityProviderTab />
        )}
      </Tabs>
    </Box>
  );
}

export default ClientBalance;
